import React from 'react'

import ContentLoader from 'react-content-loader'

import { darkModeVar } from '@web/hooks/useGlobalDetermineDarkMode'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'

import styles from './ViewImageCardLoader.module.scss'

const WIDTH = 375
const HEIGHT = 215
const MARGIN = 30
const ROWS = 3

interface RowProps {
  index: number
}

const Row = ({ index }: RowProps) => (
  <>
    <rect x="0" y={(HEIGHT + MARGIN) * index + 30} rx="4" ry="4" width="222" height="20" />
    <rect x="0" y={(HEIGHT + MARGIN) * index + 64} rx="8" ry="8" width="100%" height="160" />
  </>
)

const ViewCardImageLoader = () => {
  const dark = darkModeVar()
  const { isSsr } = useGlobalStaticStateContext()

  if (isSsr) return null

  const currentUrl = window.location.href

  return (
    <div className={styles.content_loader_area}>
      <div className={styles.inner}>
        <ContentLoader
          viewBox={`0 0 ${WIDTH} ${HEIGHT * ROWS + MARGIN * (ROWS - 1)}`}
          speed={2}
          baseUrl={currentUrl}
          backgroundColor={dark ? '#3f3f43' : '#f0f0f3'}
          foregroundColor={dark ? '#39393c' : '#f7f7f9'}
        >
          {new Array(ROWS).fill(Row).map((item, index) =>
            React.createElement(item, {
              // eslint-disable-next-line
              key: index,
              index,
            }),
          )}
        </ContentLoader>
      </div>
    </div>
  )
}

export default ViewCardImageLoader
